import React from "react";
import { Card } from "@masterteam/mt-design-react";

import "./style.scss";

const ChartCard = ({ title, children, customStyle }) => {
  return (
    <Card className="chart-dash-card" style={{ ...customStyle }}>
      <div className="chart-dash-card__header">
        <p>{title}</p>
      </div>
      {children}
    </Card>
  );
};

export default ChartCard;
